import { combineReducers } from 'redux';
import Auth from './Auth';
import Accounts from './Accounts';
export default combineReducers({
  auth: Auth,
  accounts: Accounts
});